module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "items-per-page",
    class: [{
      'disabled': _vm.loading.state
    }]
  }, [_vm._l((_vm.$lang.items_per_page.elems), function(elem) {
    return _c('a', {
      staticClass: "items-per-page__button",
      class: [{
        'active': _vm.rowsNum == elem.val
      }],
      attrs: {
        "href": "",
        "title": elem.name
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setActiveRow(elem.val)
        }
      }
    }, [_vm._v("\n        " + _vm._s(elem.val) + "\n  ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "items-per-page__text"
  }, [_vm._v(_vm._s(_vm.$lang.items_per_page.label))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d7f6c62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/ItemsPerPage.vue
// module id = 333
// module chunks = 1